// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8d958445","453":"d8fe3947","455":"af0a8f11"}[chunkId] + ".chunk.js";
};